/**
 * TMNZ admin AuthService implementation
 */

import {
  IAuthService,
  LoginParams,
  LoginResponse,
  LogoutResponse,
  CheckSessionParams,
  CheckSessionResponse,
} from './interface';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable, InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

export const AuthServiceToken = new InjectionToken<IAuthService>('AuthService');

@Injectable({
  providedIn: 'root',
})
export class WebAdminAuthService implements IAuthService {
  private baseUrl: string;
  private jwtHelper: JwtHelperService;

  public constructor(private http: HttpClient) {
    this.baseUrl = `${environment.apiUrl}/auth`;
    this.jwtHelper = new JwtHelperService();
  }

  public login(params: LoginParams): Observable<LoginResponse> {
    const url = `${this.baseUrl}/login/trustee`;
    return this.http
      .post<{ token: string; fullName: string }>(url, {
        username: params.alias,
        password: params.password,
      })
      .pipe(
        map(({ token, fullName }) => ({
          accessToken: token,
          fullName: fullName,
        })),
      );
  }

  public logout(): Observable<LogoutResponse> {
    const url = `${this.baseUrl}/logout`;
    return this.http.post<LogoutResponse>(url, {});
  }

  public checkSession(
    params: CheckSessionParams,
  ): Observable<CheckSessionResponse> {
    return of({
      expired: this.jwtHelper.isTokenExpired(params.accessToken),
      accessToken: params.accessToken,
    });
  }
}
